import { render } from "./ProviderConsentDialog.vue?vue&type=template&id=64bd6542&scoped=true"
import script from "./ProviderConsentDialog.vue?vue&type=script&lang=js"
export * from "./ProviderConsentDialog.vue?vue&type=script&lang=js"

import "./ProviderConsentDialog.vue?vue&type=style&index=0&id=64bd6542&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bd6542"]])

export default __exports__